import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    cardEndereco: {
        display: 'flex',
        alignItems: 'center',
        background: theme.palette.grey[100],
        borderRadius: '5px',
        padding: '8px',
        width: '100%'
    },
    defaultCard: {
        boxShadow: '1px 1px 1px 2px rgb(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
    },
    aviso: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        width: '100%',
        padding: theme.spacing(1),
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    avisoPedidoDestacado: {
        backgroundColor: theme.palette.success.dark,
        color: theme.palette.common.white,
    },
    avisoRotaNaoOtimizada: {
        backgroundColor: theme.palette.warning.dark,
        color: theme.palette.common.white,
    },
    confirmarBtn: {
        backgroundColor: '#00c113',
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.success.dark,
        },
        '& svg': {
            fill: theme.palette.common.white,
        }
    },
    iconInfo: {
        cursor: 'pointer',
        margin: 5,
        '& svg': {
            margin: 0,
            padding: 0
        }
    },
}));